export function getUrlArgs(defaultBasin) {
    return [
        {
            argName: "forecastStatus",
            argDesc: "Show forecasts with the specified status.",
            argExample: "prelim",
            argOptions: ["final", "prelim", "raw"],
            argDefault: "final",
            argInternal: true,
        },
        {
            argName: "customBasin",
            argDesc:
                "Add a custom basin to the basin dropdown; comma delineated list starting with the basin name followed by forecast site ids",
            argExample: "Special Custom Basin,15356000,15388960,15453500",
            argInternal: true,
        },
        {
            argName: "state",
            argDesc: "Selects the specified state from the 'State' drop-down. Expects 2-character state abbreviation.",
            argExample: "WY",
            argDefault: "CO",
        },
        {
            argName: "basin",
            argDesc: "Selects the specified basin from the 'Basin' drop down.",
            argExample: "SNAKE",
            argDefault: defaultBasin,
        },
        {
            argName: "year",
            argDesc: "Selects the specified year from the 'Year' drop-down",
            argExample: 2021,
            argDefault: "Current Year",
        },
        {
            argName: "pubDate",
            argDesc:
                "Selects the specified publication date from the 'Publication Date' drop-down. Format should be M-D.",
            argExample: "4-1",
            argDefault: "Last available publication date.",
        },
        {
            argName: "period",
            argDesc:
                "Selects the specified forecast period from the list of available forecast periods. Format is MMM-MMM.",
            argExample: "APR-JUL",
            argDefault: "all",
        },
        {
            argName: "chartWidth",
            argDesc: "Sets the chart width (in pixels).",
            argExample: "1000",
            argDefault: 800,
        },
        {
            argName: "normalType",
            argDesc: "Specifies whether the charts display forecasts as percent of median, or percent of average.",
            argExample: "AVG",
            argOptions: ["MED", "AVG"],
            argDefault: "MED",
        },
        {
            argName: "labelUnit",
            argDesc: "Specifies whether forecast data labels have units of volume or percent.",
            argExample: "PCT",
            argOptions: ["PCT", "VOL"],
            argDefault: "VOL",
        },
        {
            argName: "forecastLabels",
            argDesc:
                "Specifies whether to label each exceedence interval on the plot, or just the 50% exceedence interval.",
            argExample: "50",
            argOptions: ["ALL", "50"],
            argDefault: "ALL",
        },
        {
            argName: "showForecast",
            argDesc: "Shows the forecast on the chart.",
            argExample: "true",
            argOptions: [true, false],
            argDefault: "true",
        },
        {
            argName: "showForecastLabel",
            argDesc: "Shows labels above each forecast on the chart.",
            argExample: "false",
            argOptions: [true, false],
            argDefault: "true",
        },
        {
            argName: "showObserved",
            argDesc: "If available, shows the actual observed value",
            argExample: "true",
            argOptions: [true, false],
            argDefault: "false",
        },
        {
            argName: "showObservedLabel",
            argDesc: "If available, shows labels above the observations.",
            argExample: "true",
            argOptions: [true, false],
            argDefault: "false",
        },
        {
            argName: "showNormal",
            argDesc: "Shows the historical normal on the chart.",
            argExample: "false",
            argOptions: [true, false],
            argDefault: "false",
        },
        {
            argName: "showNormalLabel",
            argDesc: "Shows the label associated with the normal",
            argExample: "false",
            argOptions: [true, false],
            argDefault: "false",
        },
        {
            argName: "showMax",
            argDesc: "Shows the historical maximum.",
            argExample: "true",
            argOptions: [true, false],
            argDefault: "false",
        },
        {
            argName: "showMaxLabel",
            argDesc: "Shows the label associated with the historical maximum.",
            argExample: "false",
            argOptions: [true, false],
            argDefault: "false",
        },
        {
            argName: "showMaxYear",
            argDesc: "Show the year associated with the historical maximum.",
            argExample: "false",
            argOptions: [true, false],
            argDefault: "false",
        },
        {
            argName: "showMin",
            argDesc: "Shows the historical minimum.",
            argExample: "true",
            argOptions: [true, false],
            argDefault: "false",
        },
        {
            argName: "showMinLabel",
            argDesc: "Shows the label associated with the historical minimum.",
            argExample: "false",
            argOptions: [true, false],
            argDefault: "false",
        },
        {
            argName: "showMinYear",
            argDesc: "Show the year associated with the historical minimum.",
            argExample: "false",
            argOptions: [true, false],
            argDefault: "false",
        },
        {
            argName: "showNumberObservations",
            argDesc: "Shows the number of historical observations.",
            argExample: "false",
            argOptions: [true, false],
            argDefault: "false",
        },
        {
            argName: "hideEmpty",
            argDesc: "Hides forecast points that do not have a forecast.",
            argExample: "true",
            argOptions: [true, false],
            argDefault: "true",
        },
        {
            argName: "hideNeg",
            argDesc: "Constrains the charts to show only positive forecasts values.",
            argExample: "true",
            argOptions: [true, false],
            argDefault: "true",
        },
    ];
}
